import {Grid} from '@logistics-frontend/blocks'
import {HeaderButton} from '@logistics-frontend/order-layout-blocks'
import clsx from 'clsx'
import {useState} from 'react'

import {desktopClasses} from './Menu.classes'

type Props = {
  text: string
  id: string
  items: {
    text: string
    href: string
  }[]
}

export function SingleColumnMenu({links}: {links: Props[]}) {
  const [activeMenuItem, setActiveMenuItem] = useState<string>(links[0].id)

  return (
    <Grid direction="row" container>
      <Grid className={desktopClasses.titles} direction="column" container item xs>
        {links.map(({text, id}) => (
          <Grid key={`menu-${id}`} alignItems="flex-start" container>
            <Grid item>
              <Grid direction="column" container>
                <Grid
                  onMouseEnter={() => {
                    setActiveMenuItem(id)
                  }}
                  item
                  xs
                >
                  <HeaderButton active={activeMenuItem === id} variant="pseudo" transparent>
                    {text}
                  </HeaderButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {links.map(({id, items}) => (
        <Grid
          key={`link-${id}`}
          className={clsx(desktopClasses.menus, {[desktopClasses.visible]: activeMenuItem === id})}
          item
          xs
        >
          {activeMenuItem === id ? <SubMenu items={items} /> : null}
        </Grid>
      ))}
    </Grid>
  )
}

export function SubMenu({items}: {items: Props['items']}) {
  return (
    <>
      {items.map(({href, text}, index) => (
        <Grid key={`menu-item-${index}`} item xs>
          <HeaderButton href={href} size="s" variant="pseudo" transparent>
            {text}
          </HeaderButton>
        </Grid>
      ))}
    </>
  )
}
